import { render, staticRenderFns } from "./ChartTorta.vue?vue&type=template&id=6dc6b132"
import script from "./ChartTorta.vue?vue&type=script&lang=js"
export * from "./ChartTorta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports